module.exports = __webpack_public_path__ + "img/tumonster.9867e35f.png";